import React from "react";
import { NavLink } from "react-router-dom";
import "./FiltroClasificacion.component.scss";

const FiltroClasificacionComponent = ({ clasificaciones = [] }) => {
  return (
    <ul className="FiltroClasificacion">
      {clasificaciones.map((clasificacion) => {
        const { datos } = clasificacion;
        return (
          <NavLink
            key={clasificacion.id}
            to={`/Catalogo/${datos.Cabecera}`}
            hash={`${clasificacion.id}`}
            activeClassName="FiltroClasificacion__Actual"
          >
            <li>{datos.Cabecera}</li>
          </NavLink>
        );
      })}
    </ul>
  );
};

export default FiltroClasificacionComponent;
